import { render, staticRenderFns } from "./RegulateProgram.vue?vue&type=template&id=2c7eaafe"
import script from "./RegulateProgram.vue?vue&type=script&lang=js"
export * from "./RegulateProgram.vue?vue&type=script&lang=js"
import style0 from "./RegulateProgram.vue?vue&type=style&index=0&id=2c7eaafe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports